import reducer from './reducers'
import { EntityState as E } from './types'

export * from './selectors'

export default reducer
export type EntityState = E
